/** @jsx h */
import { labels } from '../config';

const FilterCheckbox = ({
  option,
  filterName,
  handleChange,
  pluginNamespace,
}) => {
  return (
    <div class="input-filter">
      <input
        id={`${filterName}-${option.value}`}
        type="checkbox"
        class="input-filter__input"
        name={`${pluginNamespace}[filter][]`}
        value={`${filterName}:${option.value}`}
        data-label={`${filterName}-${option.label}`}
        onChange={handleChange}
        checked={option.selected}
      />
      <label
        htmlFor={`${filterName}-${option.value}`}
        class="input-filter__label"
      >
        <span class="input-filter__label-text">{option.label}</span>
        <span class="input-filter__hits">
          <span class="sr-only">{labels.faceting.filterHits}:</span>
          {option.documentCount}
        </span>
      </label>
    </div>
  );
};

export default FilterCheckbox;
